export const SPECIAL_TABLE_CELL = 'SPECIAL_TABLE_CELL'
